import { Controller, useFormContext } from "react-hook-form";
import { useMemo } from "react";

import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";
import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import Select from "ds/components/Select";

import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../constants";
import useAttachableWorkerPools from "../hooks/useAttachableWorkerPools";
import { NewScanScheduleStep, NewScanScheduleFormFields } from "../types";

const NewScanScheduleStepAttachWorkerPool = () => {
  const { control, watch } = useFormContext<NewScanScheduleFormFields>();

  const space = watch("space");

  const { workerPools, loading, error } = useAttachableWorkerPools(space);

  const workerPoolOptions = useMemo(
    () => workerPools.map(({ id, name }) => ({ value: id, label: name })),
    [workerPools]
  );

  const helperText = error ? "Could not load worker pools." : undefined;

  return (
    <FullScreenModalBody>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.AttachWorkerPool]}
      />
      <Box direction="column">
        <Controller
          name="workerPoolId"
          control={control}
          rules={{ required: "Worker pool is required." }}
          render={({ field, fieldState }) => (
            <FormField
              label="Worker pool"
              helperText={helperText}
              error={fieldState.error?.message}
            >
              {({ ariaInputProps }) => (
                <Select
                  value={field.value}
                  items={workerPoolOptions}
                  isLoading={loading}
                  onChange={field.onChange}
                  placeholder="Please select"
                  isError={!!fieldState.error}
                  {...ariaInputProps}
                />
              )}
            </FormField>
          )}
        />
      </Box>
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepAttachWorkerPool;
